// Constants for localStorage
export const STORAGE_KEYS = {
  WATCHED_LECTURES: 'femgym_watched_lectures',
  LAST_POSITION: 'femgym_last_position',
  VIEW_STATE: 'femgym_view_state'
};

// Threshold for considering a video watched (90%)
export const WATCHED_THRESHOLD = 0.9;

// API base URL
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string;
